import React from 'react';
import './TaskEventList.css';
import { MdCallReceived, MdOutlineCallMade } from "react-icons/md";
import { TiBusinessCard } from "react-icons/ti";
import { humanizeEvent, deriveCallerContext, formatAge, extractPreviousTaskData } from '../helpers/taskEvents';


const TaskEventList = ({ events }) => {
  // Read-only detail: no click-to-fetch behavior

  if (!events.length) return <p>No events found.</p>;

  // Extract caller, called, and conversation title from the first event with task_attributes
  const callerAndCalled = deriveCallerContext(events);


  return (
    <div>
      {callerAndCalled && (
        <div style={{ margin: '1rem 0', width: '100%', fontWeight: 'bold', fontSize: '1rem', display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem'}}><TiBusinessCard />{callerAndCalled.conversationTitle || '—'}</span> &nbsp;&nbsp;
          <span style={{ display: 'flex', alignItems: 'center'}}><MdOutlineCallMade />{callerAndCalled.caller}</span> &nbsp;&nbsp;
          <span style={{ display: 'flex', alignItems: 'center'}}><MdCallReceived />{callerAndCalled.called}</span>
        </div>
      )}
      <div style={{ width: '100%', overflowX: 'auto' }}>
      <table className="task-event-table" style={{ minWidth: 700 }}>
        <thead>
          <tr>
            <th>Priority</th>
            <th>Event Type</th>
            <th>Worker</th>
            <th>Timestamp</th>
            <th>Queue</th>
            <th>Workflow</th>
            <th>Age</th>
            <th>Channel</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event, index) => {
            const { payload = {} } = event;
            if (event.eventType === 'task.updated') {
              return (
                <tr key={index}>
                  <td colSpan="9" style={{ fontStyle: 'italic', color: '#555', textAlign: 'center' }}>
                    Task updated
                  </td>
                </tr>
              );
            }
            return (
              <tr key={index}>
                <td>{payload.task_priority || '-'}</td>
                <td>{humanizeEvent(event)}</td>
                <td>{payload.worker_name || '-'}</td>
                <td>{new Date(event.timestamp).toLocaleString()}</td>
                <td>{payload.task_queue_name || '-'}</td>
                <td>{payload.workflow_name || '-'}</td>
                <td>{formatAge(payload.task_age)}</td>
                <td>{payload.task_channel_unique_name}</td>
                <td>{payload.task_assignment_status || '-'}</td>
              </tr>
            );
          })}
        </tbody>
  </table>
  </div>

      {/* Show previous task info only once if present */}
      {( () => { const previousTaskData = extractPreviousTaskData(events); return previousTaskData ? (
        <div style={{ marginTop: 20, padding: '10px', background: '#f3f3f3', border: '1px solid #ddd' }}>
          <h4>Dit is een callback request!</h4>
          <h5>Originele call informatie:</h5>
          {previousTaskData.previousTaskSid && (<p><strong>Previous Task SID:</strong> {previousTaskData.previousTaskSid}</p>)}
          {previousTaskData.previosCallSid && (<p><strong>Previous Call SID:</strong> {previousTaskData.previosCallSid}</p>)}
          {previousTaskData.name && (<p><strong>Naam:</strong> {previousTaskData.name}</p>)}
        </div>) : null; })()}
      {/* Read-only: removed status fetch, tabs, and additional modal */}
    </div>
  );
};

export default TaskEventList;
